import { ReactElement } from 'react';
import { GridRenderCellParams } from '@mui/x-data-grid';

import DashboardActionButton from './dashboard-action';
import DataGridBlankLabel from '../../shared/components/ui/datagrid/datagrid-blank-label';
import { IColumnAction } from '../../shared/interfaces/datagrid.interface';

export const columns: IColumnAction[] = [
  {
    field: 'code',
    headerName: 'Employee Code',
    flex: 1,
    disableColumnMenu: true,
    renderCell: (e: GridRenderCellParams): ReactElement => {
      return DataGridBlankLabel(e.row.code);
    },
  },
  {
    field: 'status',
    headerName: 'Status',
    flex: 1,
    disableColumnMenu: true,
    renderCell: (e: GridRenderCellParams): ReactElement => {
      return DataGridBlankLabel(e.row.status);
    },
  },
  {
    field: 'lastname',
    headerName: 'Last Name',
    flex: 1,
    disableColumnMenu: true,
    renderCell: (e: GridRenderCellParams): ReactElement => {
      return DataGridBlankLabel(e.row.lastname);
    },
  },
  {
    field: 'firstname',
    headerName: 'First Name',
    flex: 1,
    disableColumnMenu: true,
    renderCell: (e: GridRenderCellParams): ReactElement => {
      return DataGridBlankLabel(e.row.firstname);
    },
  },
  {
    field: 'middlename',
    headerName: 'Middle Name',
    flex: 1,
    disableColumnMenu: true,
    renderCell: (e: GridRenderCellParams): ReactElement => {
      return DataGridBlankLabel(e.row.middlename);
    },
  },
  {
    field: 'company',
    headerName: 'Affiliate Description',
    flex: 1,
    disableColumnMenu: true,
    renderCell: (e: GridRenderCellParams): ReactElement => {
      return DataGridBlankLabel(e.row.company);
    },
  },
  {
    field: 'actions',
    headerName: '',
    align: 'center',
    type: 'actions',
    flex: 1,
    disableColumnMenu: true,
    getActions: ({ row: { slug, status } }): any => {
      if (!slug) return [];

      return [<DashboardActionButton key={slug} slug={slug} status={status} />];
    },
  },
];
